export const COURSE_SYLLABUS_CARD_ID = 'sy_course_card'
